import { render, staticRenderFns } from "./ActionItemList.vue?vue&type=template&id=4bb7fe86&scoped=true"
import script from "./ActionItemList.vue?vue&type=script&lang=js"
export * from "./ActionItemList.vue?vue&type=script&lang=js"
import style0 from "./ActionItemList.vue?vue&type=style&index=0&id=4bb7fe86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7fe86",
  null
  
)

export default component.exports